(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[7145],{

/***/ 62253:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "h": function() { return /* binding */ ExternalLinkIcon; }
});

// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__(59499);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/objectWithoutProperties.js + 1 modules
var objectWithoutProperties = __webpack_require__(4730);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(32125);
// EXTERNAL MODULE: ./src/styles/theme.ts
var theme = __webpack_require__(49642);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
;// CONCATENATED MODULE: ./src/components/elements/Icon/ExternalLink/external-link.svg
var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var SvgExternalLink = function SvgExternalLink(props) {
  return /*#__PURE__*/react.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 12 12"
  }, props), _g || (_g = /*#__PURE__*/react.createElement("g", {
    "data-name": "group2691"
  }, /*#__PURE__*/react.createElement("path", {
    "data-name": "rectangle139",
    d: "M3 1v8h8V1H3M2 0h10v10H2Z"
  }), /*#__PURE__*/react.createElement("path", {
    "data-name": "path293",
    d: "M7.83 12H0V4.245h1V11h6.83Z"
  }))));
};
/* harmony default export */ var external_link = (SvgExternalLink);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
;// CONCATENATED MODULE: ./src/components/elements/Icon/ExternalLink/index.tsx


var _excluded = ["size"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }





var ExternalLinkIcon = function ExternalLinkIcon(_ref) {
  var size = _ref.size,
      props = (0,objectWithoutProperties/* default */.Z)(_ref, _excluded);

  return /*#__PURE__*/(0,jsx_runtime.jsx)(StyledIcon, _objectSpread({
    "aria-label": "\u65B0\u898F\u30BF\u30D6\u3067\u958B\u304F",
    size: size
  }, props));
};
var StyledIcon = (0,styled_components_browser_esm/* default */.ZP)(external_link).withConfig({
  displayName: "ExternalLink__StyledIcon",
  componentId: "sc-12ugb1p-0"
})(["transition:fill 0.3s ease-out;fill:", ";width:", ";height:", ";@media screen and (max-width:1047px){width:12px;height:12px;}"], theme/* theme.colors.trialBlue */.r.colors.trialBlue, function (_ref2) {
  var size = _ref2.size;
  return size === 'small' ? '12px' : '16px';
}, function (_ref3) {
  var size = _ref3.size;
  return size === 'small' ? '12px' : '16px';
});

/***/ }),

/***/ 53300:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "k": function() { return /* binding */ LinkCard; }
});

// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__(59499);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/objectWithoutProperties.js + 1 modules
var objectWithoutProperties = __webpack_require__(4730);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(41664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ./node_modules/react-scroll/modules/index.js
var modules = __webpack_require__(66261);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(32125);
// EXTERNAL MODULE: ./src/styles/theme.ts
var theme = __webpack_require__(49642);
// EXTERNAL MODULE: ./src/components/elements/Icon/ExternalLink/index.tsx + 1 modules
var ExternalLink = __webpack_require__(62253);
// EXTERNAL MODULE: ./src/components/elements/RoundedLabel/index.tsx
var RoundedLabel = __webpack_require__(51342);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
;// CONCATENATED MODULE: ./src/components/elements/LinkCard/Card.tsx






var Card = function Card(_ref) {
  var imgPath = _ref.imgPath,
      title = _ref.title,
      detail = _ref.detail,
      isExternalLink = _ref.isExternalLink;
  return /*#__PURE__*/(0,jsx_runtime.jsxs)(Wrapper, {
    children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(Grid, {
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)(ImageWrapper, {
        children: /*#__PURE__*/(0,jsx_runtime.jsx)("img", {
          src: imgPath,
          width: "100%",
          alt: ""
        })
      }), title && /*#__PURE__*/(0,jsx_runtime.jsx)(Title, {
        children: title
      })]
    }), detail && /*#__PURE__*/(0,jsx_runtime.jsx)(Detail, {
      children: /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)("span", {
          children: detail
        }), isExternalLink && /*#__PURE__*/(0,jsx_runtime.jsx)(StyledExternalLinkIcon, {
          size: "small"
        })]
      })
    })]
  });
};
var Wrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "Card__Wrapper",
  componentId: "sc-1z091jq-0"
})(["width:316px;height:100%;background:", ";border-radius:8px;display:flex;flex-direction:column;@media screen and (max-width:1047px){width:100%;}"], theme/* theme.colors.backgroundPaleBlue */.r.colors.backgroundPaleBlue);
var Grid = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "Card__Grid",
  componentId: "sc-1z091jq-1"
})(["display:grid;grid-template-columns:20px 1fr 20px;grid-template-rows:1fr auto 17px;@media screen and (max-width:1047px){grid-template-rows:1fr auto 17px;}"]);
var ImageWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "Card__ImageWrapper",
  componentId: "sc-1z091jq-2"
})(["display:flex;justify-content:center;grid-area:1 / 1 / 4 / 4;height:188px;transition:opacity 0.25s ease;@media screen and (max-width:1047px){height:199px;}"]);
var Title = (0,styled_components_browser_esm/* default */.ZP)(RoundedLabel/* RoundedLabel */.I).withConfig({
  displayName: "Card__Title",
  componentId: "sc-1z091jq-3"
})(["grid-area:2 / 2 / 3 / 3;"]);
var Detail = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "Card__Detail",
  componentId: "sc-1z091jq-4"
})(["background:#fff;padding:18px 26px 22px;border-width:0 4px 4px 4px;border-color:", ";border-style:solid;border-radius:0 0 8px 8px;line-height:1.4;letter-spacing:0.08em;flex:1;@media screen and (max-width:1047px){padding:13px 18px 16px;font-size:14px;}"], theme/* theme.colors.backgroundPaleBlue */.r.colors.backgroundPaleBlue);
var StyledExternalLinkIcon = (0,styled_components_browser_esm/* default */.ZP)(ExternalLink/* ExternalLinkIcon */.h).withConfig({
  displayName: "Card__StyledExternalLinkIcon",
  componentId: "sc-1z091jq-5"
})(["margin-left:8px;"]);
;// CONCATENATED MODULE: ./src/components/elements/LinkCard/index.tsx


var _excluded = ["link", "isExternalLink", "isScroll", "newWindow", "forceReload"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }







var LinkCard = function LinkCard(_ref) {
  var link = _ref.link,
      isExternalLink = _ref.isExternalLink,
      isScroll = _ref.isScroll,
      newWindow = _ref.newWindow,
      forceReload = _ref.forceReload,
      props = (0,objectWithoutProperties/* default */.Z)(_ref, _excluded);

  if (link) {
    if (isExternalLink) {
      return /*#__PURE__*/(0,jsx_runtime.jsx)(StyledLink, {
        href: link,
        target: "_blank",
        rel: "noopener noreferrer",
        children: /*#__PURE__*/(0,jsx_runtime.jsx)(Card, _objectSpread(_objectSpread({}, props), {}, {
          isExternalLink: isExternalLink
        }))
      });
    }

    if (isScroll) {
      return /*#__PURE__*/(0,jsx_runtime.jsx)(StyledScroll, {
        to: link,
        smooth: true,
        duration: 600,
        children: /*#__PURE__*/(0,jsx_runtime.jsx)(Card, _objectSpread({}, props))
      });
    }

    var cardLink = /*#__PURE__*/(0,jsx_runtime.jsx)(StyledLink, {
      href: forceReload ? link : undefined,
      target: newWindow ? '_blank' : undefined,
      rel: newWindow ? 'noopener noreferrer' : undefined,
      children: /*#__PURE__*/(0,jsx_runtime.jsx)(Card, _objectSpread({}, props))
    });

    if (forceReload) return cardLink;
    return /*#__PURE__*/(0,jsx_runtime.jsx)((link_default()), {
      href: link,
      passHref: true,
      children: cardLink
    });
  }

  return /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
    children: /*#__PURE__*/(0,jsx_runtime.jsx)(Card, _objectSpread({}, props))
  });
};
var LinkStyle = (0,styled_components_browser_esm/* css */.iv)(["display:block;width:316px;white-space:pre-wrap;&:hover > div > div:first-of-type{> div > img{opacity:0.6;transition:opacity 0.25s ease;}> div:nth-of-type(2){background:", ";transition:background 0.25s ease;}}@media screen and (max-width:1047px){width:335px;}"], theme/* theme.colors.hoverLightBlue */.r.colors.hoverLightBlue);
var StyledLink = styled_components_browser_esm/* default.a.withConfig */.ZP.a.withConfig({
  displayName: "LinkCard__StyledLink",
  componentId: "sc-1q4bvyj-0"
})(["", ""], LinkStyle);
var StyledScroll = (0,styled_components_browser_esm/* default */.ZP)(modules/* Link */.rU).withConfig({
  displayName: "LinkCard__StyledScroll",
  componentId: "sc-1q4bvyj-1"
})(["", ""], LinkStyle);

/***/ }),

/***/ 51342:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "I": function() { return /* binding */ RoundedLabel; }
/* harmony export */ });
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(32125);
/* harmony import */ var _styles_theme__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(49642);


var RoundedLabel = styled_components__WEBPACK_IMPORTED_MODULE_1__/* ["default"].div.withConfig */ .ZP.div.withConfig({
  displayName: "RoundedLabel",
  componentId: "sc-1s4si24-0"
})(["color:#fff;background:", ";border-radius:23px;border:2px solid #fff;padding:12px 20px;font-size:17px;line-height:1.1;letter-spacing:0.04em;font-weight:700;word-break:break-all;text-align:center;position:relative;transition:background 0.25s ease;@media screen and (max-width:1047px){border-radius:25px;font-size:15px;padding:12px 50px;}"], _styles_theme__WEBPACK_IMPORTED_MODULE_0__/* .theme.colors.trialBlue */ .r.colors.trialBlue);

/***/ }),

/***/ 70770:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "N": function() { return /* binding */ SectionTitle; }
/* harmony export */ });
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(32125);
/* harmony import */ var _styles_theme__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(49642);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85893);




var SectionTitle = function SectionTitle(_ref) {
  var titleText = _ref.titleText,
      subTitleText = _ref.subTitleText,
      enTitleText = _ref.enTitleText,
      color = _ref.color,
      _ref$as = _ref.as,
      as = _ref$as === void 0 ? 'h3' : _ref$as;
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(SectionTitleDiv, {
    children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(TitleText, {
      color: color,
      as: as,
      children: titleText
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(EnTitleText, {
      color: color,
      as: as,
      children: enTitleText
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(SubTitleText, {
      color: color,
      children: subTitleText
    })]
  });
};
var SectionTitleDiv = styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"].div.withConfig */ .ZP.div.withConfig({
  displayName: "SectionTitle__SectionTitleDiv",
  componentId: "sc-17562y0-0"
})(["text-align:center;"]);
var TitleText = styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"].h3.withConfig */ .ZP.h3.withConfig({
  displayName: "SectionTitle__TitleText",
  componentId: "sc-17562y0-1"
})(["font-weight:bold;font-size:42px;line-height:50px;margin-bottom:6px;color:", ";font-family:", ";@media screen and (max-width:1047px){display:none;}"], function (_ref2) {
  var color = _ref2.color;
  return color === 'normal' ? "".concat(_styles_theme__WEBPACK_IMPORTED_MODULE_0__/* .theme.colors.trialBlue */ .r.colors.trialBlue) : "white";
}, _styles_theme__WEBPACK_IMPORTED_MODULE_0__/* .theme.fontEn */ .r.fontEn);
var SubTitleText = styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"].p.withConfig */ .ZP.p.withConfig({
  displayName: "SectionTitle__SubTitleText",
  componentId: "sc-17562y0-2"
})(["font-size:18px;line-height:26px;color:", ";@media screen and (max-width:1047px){font-size:23px;line-height:1.2;font-weight:700;}"], function (_ref3) {
  var color = _ref3.color;
  return color === 'normal' ? "".concat(_styles_theme__WEBPACK_IMPORTED_MODULE_0__/* .theme.colors.overlay */ .r.colors.overlay) : "white";
});
var EnTitleText = styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"].h3.withConfig */ .ZP.h3.withConfig({
  displayName: "SectionTitle__EnTitleText",
  componentId: "sc-17562y0-3"
})(["@media screen and (min-width:1048px){font-weight:bold;font-size:42px;line-height:50px;margin-bottom:6px;color:", ";font-family:", ";}@media screen and (max-width:1047px){font-size:23px;line-height:1.2;font-weight:700;}"], function (_ref4) {
  var color = _ref4.color;
  return color === 'normal' ? "".concat(_styles_theme__WEBPACK_IMPORTED_MODULE_0__/* .theme.colors.trialBlue */ .r.colors.trialBlue) : "white";
}, _styles_theme__WEBPACK_IMPORTED_MODULE_0__/* .theme.fontEn */ .r.fontEn);

/***/ }),

/***/ 75795:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "T": function() { return /* binding */ SectionTitleBackground; }
/* harmony export */ });
/* harmony import */ var _workspace_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(59499);
/* harmony import */ var _workspace_node_modules_next_dist_compiled_babel_runtime_helpers_esm_objectWithoutProperties__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(4730);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(32125);
/* harmony import */ var _styles_theme__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(49642);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(85893);


var _excluded = ["children", "showTopArrow"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0,_workspace_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }




var SectionTitleBackground = function SectionTitleBackground(_ref) {
  var children = _ref.children,
      _ref$showTopArrow = _ref.showTopArrow,
      showTopArrow = _ref$showTopArrow === void 0 ? true : _ref$showTopArrow,
      rest = (0,_workspace_node_modules_next_dist_compiled_babel_runtime_helpers_esm_objectWithoutProperties__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(_ref, _excluded);

  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)(Wrapper, _objectSpread(_objectSpread({
    showTopArrow: showTopArrow
  }, rest), {}, {
    children: children
  }));
};
var Arrow = (0,styled_components__WEBPACK_IMPORTED_MODULE_4__/* .css */ .iv)(["content:'';position:absolute;left:0;width:0;height:0;border-style:solid;border-width:175px 50vw 0 50vw;@media screen and (max-width:1047px){border-width:40px 50vw 0 50vw;}"]);
var Wrapper = styled_components__WEBPACK_IMPORTED_MODULE_4__/* ["default"].div.withConfig */ .ZP.div.withConfig({
  displayName: "SectionTitleBackground__Wrapper",
  componentId: "sc-venkor-0"
})(["position:relative;background-color:", ";padding:", ";&::before{", ";}&::after{", ";bottom:0;border-color:", ";}@media screen and (max-width:1047px){padding:", ";}"], function (_ref2) {
  var bgColor = _ref2.bgColor;
  return bgColor === 'trial-blue' ? "".concat(_styles_theme__WEBPACK_IMPORTED_MODULE_1__/* .theme.colors.trialBlue */ .r.colors.trialBlue) : bgColor === 'thin-blue' ? "".concat(_styles_theme__WEBPACK_IMPORTED_MODULE_1__/* .theme.colors.backgroundBlue */ .r.colors.backgroundBlue) : '#fff';
}, function (_ref3) {
  var padding = _ref3.padding;
  return padding.pc;
}, function (_ref4) {
  var _ref4$showTopArrow = _ref4.showTopArrow,
      showTopArrow = _ref4$showTopArrow === void 0 ? true : _ref4$showTopArrow,
      outerBgColor = _ref4.outerBgColor;
  return showTopArrow ? (0,styled_components__WEBPACK_IMPORTED_MODULE_4__/* .css */ .iv)(["", ";top:0;border-color:", " transparent transparent transparent;"], Arrow, outerBgColor === 'thin-blue' ? _styles_theme__WEBPACK_IMPORTED_MODULE_1__/* .theme.colors.backgroundBlue */ .r.colors.backgroundBlue : '#fff') : (0,styled_components__WEBPACK_IMPORTED_MODULE_4__/* .css */ .iv)(["content:none;"]);
}, Arrow, function (_ref5) {
  var bgColor = _ref5.bgColor,
      outerBgColor = _ref5.outerBgColor;
  return "".concat(bgColor === 'trial-blue' ? "".concat(_styles_theme__WEBPACK_IMPORTED_MODULE_1__/* .theme.colors.trialBlue */ .r.colors.trialBlue) : bgColor === 'thin-blue' ? "".concat(_styles_theme__WEBPACK_IMPORTED_MODULE_1__/* .theme.colors.backgroundBlue */ .r.colors.backgroundBlue) : '#fff', " \n      ").concat(outerBgColor === 'thin-blue' ? "".concat(_styles_theme__WEBPACK_IMPORTED_MODULE_1__/* .theme.colors.backgroundBlue */ .r.colors.backgroundBlue) : '#fff', " \n      transparent \n      ").concat(outerBgColor === 'thin-blue' ? "".concat(_styles_theme__WEBPACK_IMPORTED_MODULE_1__/* .theme.colors.backgroundBlue */ .r.colors.backgroundBlue) : '#fff');
}, function (_ref6) {
  var padding = _ref6.padding;
  return padding.sp;
});

/***/ }),

/***/ 22978:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "F": function() { return /* binding */ Head; }
/* harmony export */ });
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(9008);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(next_head__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85893);




var Head = function Head(_ref) {
  var _ogp$image, _ogp$type;

  var title = _ref.title,
      _ref$hasTitleSuffix = _ref.hasTitleSuffix,
      hasTitleSuffix = _ref$hasTitleSuffix === void 0 ? true : _ref$hasTitleSuffix,
      description = _ref.description,
      noindex = _ref.noindex,
      ogp = _ref.ogp;
  var ogpImage = (_ogp$image = ogp === null || ogp === void 0 ? void 0 : ogp.image) !== null && _ogp$image !== void 0 ? _ogp$image : {
    src: 'https://trial-holdings.inc/images/ogp.png',
    width: 1200,
    height: 630
  };
  var titleText = hasTitleSuffix ? "".concat(title, " | \u30C8\u30E9\u30A4\u30A2\u30EB\u30DB\u30FC\u30EB\u30C7\u30A3\u30F3\u30B0\u30B9") : title;
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)((next_head__WEBPACK_IMPORTED_MODULE_0___default()), {
    children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("title", {
      children: titleText
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("meta", {
      name: "description",
      content: description
    }), noindex && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("meta", {
      name: "robots",
      content: "noindex, nofollow"
    }), ogp && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.Fragment, {
      children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("meta", {
        property: "og:type",
        content: (_ogp$type = ogp.type) !== null && _ogp$type !== void 0 ? _ogp$type : 'website'
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("meta", {
        property: "og:url",
        content: "https://trial-holdings.inc/".concat(ogp.url)
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("meta", {
        property: "og:title",
        content: ogp.title || titleText
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("meta", {
        property: "og:description",
        content: description
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("meta", {
        property: "og:image",
        content: ogpImage.src
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("meta", {
        property: "og:image:width",
        content: "".concat(ogpImage.width)
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("meta", {
        property: "og:image:height",
        content: "".concat(ogpImage.height)
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("meta", {
        property: "og:site_name",
        content: "\u30C8\u30E9\u30A4\u30A2\u30EB\u30DB\u30FC\u30EB\u30C7\u30A3\u30F3\u30B0\u30B9"
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("meta", {
        property: "og:locale",
        content: "ja_JP"
      })]
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("link", {
      rel: "icon",
      href: "/images/favicon.ico"
    })]
  });
};

/***/ }),

/***/ 16415:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* reexport */ BusinessPage; }
});

// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__(59499);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/objectWithoutProperties.js + 1 modules
var objectWithoutProperties = __webpack_require__(4730);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(32125);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
;// CONCATENATED MODULE: ./src/components/pages/Business/business-links.tsx



var isExternalLink = true;
var businessLinks = [{
  id: 'retail',
  anchorImgPath: '/images/business-retail-links.svg',
  title: '流通小売事業',
  engTitle: 'Distribution Retail',
  titleImgPath: '/images/business-retail.svg',
  businessContent: /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)("p", {
      children: "\u30C8\u30E9\u30A4\u30A2\u30EB\u306F\u300E\u3042\u306A\u305F\u306E\u300C\u751F\u6D3B\u5FC5\u9700\u5E97\u300D\u3002\u300F\u3092\u3001\u897F\u53CB\u306F\u300E\u300C\u897F\u53CB\u304C\u8EAB\u8FD1\u306B\u3042\u308B\u3057\u3042\u308F\u305B\u300D\u3092\u3081\u3056\u3057\u3066\u300F\u3092\u4F7F\u547D\u3068\u3057\u3001\u6311\u6226\u3092\u7D9A\u3051\u3066\u304A\u308A\u307E\u3059\u3002\u3055\u3089\u306B\u3001\u5F53\u793E\u30B0\u30EB\u30FC\u30D7\u306E\u7D71\u5408\u30D3\u30B8\u30E7\u30F3\u3068\u3057\u3066\u300C\u8CB7\u3044\u7269\u3092\u697D\u3057\u304F\u3001\u66AE\u3089\u3057\u3092\u8C4A\u304B\u306B\u3002\u300D\u3092\u63B2\u3052\u3001\u65B0\u3057\u3044\u4FA1\u5024\u3092\u304A\u5BA2\u3055\u307E\u3078\u304A\u5C4A\u3051\u3057\u3066\u307E\u3044\u308A\u307E\u3059\u3002"
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
      children: "\u51FA\u5E97\u30D5\u30A9\u30FC\u30DE\u30C3\u30C8\u306F\u3001\u5C0F\u578B\u304B\u3089\u5927\u578B\u307E\u3067\u591A\u5C90\u306B\u6E21\u308A\u3001\u65E5\u672C\u5168\u56FD\u306B\u5E97\u8217\u3092\u5C55\u958B\u3057\u3066\u304A\u308A\u307E\u3059\u3002"
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
      children: "\u5546\u54C1\u30E9\u30A4\u30F3\u30CA\u30C3\u30D7\u306F\u3001\u98DF\u54C1\uFF08\u7279\u306B\u751F\u9BAE\u98DF\u54C1\uFF09\u306B\u6CE8\u529B\u3057\u3066\u304A\u308A\u3001\u3053\u3060\u308F\u308A\u306E\u304A\u3044\u3057\u3055\u3092\u8FFD\u6C42\u3057\u3066\u304A\u308A\u307E\u3059\u3002\u975E\u98DF\u54C1\u306F\u751F\u6D3B\u7528\u54C1\u3084\u30CF\u30FC\u30C9\u7528\u54C1\u3092\u53D6\u308A\u6271\u3063\u3066\u304A\u308A\u307E\u3059\u3002"
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
      children: "\u4FA1\u683C\u6226\u7565\u306F\u3001EDLP\uFF08Every Day Low Price\uFF09\u3092\u57FA\u672C\u65B9\u91DD\u3068\u3057\u3066\u304A\u308A\u3001\u7AF6\u4E89\u529B\u3042\u308B\u4FA1\u683C\u63D0\u6848\u3092\u884C\u3063\u3066\u304A\u308A\u307E\u3059\u3002"
    })]
  }),
  companies: [{
    link: 'https://trial-holdings.inc/',
    imgPath: '/images/OurBusiness_logo_TRIAL holdings.webp',
    name: '株式会社トライアルホールディングス（持株会社）',
    isExternalLink: isExternalLink
  }, {
    link: 'https://www.trial-net.co.jp/',
    imgPath: '/images/cardlink-logo-traial.webp',
    name: '株式会社トライアルカンパニー',
    isExternalLink: isExternalLink
  }, {
    imgPath: '/images/business_retail_dummy.svg',
    name: '株式会社トライアルストアーズ'
  }, {
    imgPath: '/images/Logo_TRIALGO_1L_1.png',
    name: '株式会社トライアルGO'
  }, {
    imgPath: '/images/business_retail_dummy.svg',
    name: '株式会社魚寅'
  }, {
    link: 'https://www.seiyu.co.jp/',
    imgPath: '/images/business_SEIYU.png',
    name: '株式会社西友',
    isExternalLink: isExternalLink
  }, {
    imgPath: '/images/business_retail_dummy.svg',
    name: '株式会社西友プロキュアメント'
  }, {
    imgPath: '/images/business_retail_dummy.svg',
    name: '株式会社西友サービス'
  }, {
    imgPath: '/images/business_TRIAL_Supercenter.png',
    name: '株式会社トライアルスーパーセンター'
  }, {
    imgPath: '/images/business_RIALT.png',
    name: '株式会社RIALT'
  }, {
    link: 'https://meijiya-kohaku.co.jp/',
    imgPath: '/images/business_meijiya.png',
    name: '株式会社明治屋',
    isExternalLink: isExternalLink
  }, {
    imgPath: '/images/business_kohaku_hompo.png',
    name: '株式会社こはく本舗'
  }, {
    imgPath: '/images/business_retail_dummy.svg',
    name: '株式会社トライアルフードパーク'
  }, {
    link: 'https://www.tls-net.co.jp/',
    imgPath: '/images/business-tls.webp',
    name: '株式会社MLS',
    isExternalLink: isExternalLink
  }, {
    link: 'https://su-pay.jp/',
    imgPath: '/images/OurBusiness_logo_SU-PAY.webp',
    name: '株式会社SU-PAY',
    isExternalLink: isExternalLink
  }, {
    link: 'https://trialcars.co.jp/',
    imgPath: '/images/business_trial_cars.svg',
    name: '株式会社トライアルカーズ',
    isExternalLink: isExternalLink
  }, {
    imgPath: '/images/business_retail_dummy.svg',
    name: '株式会社トライアル・インシュアランス・サービス'
  }, {
    imgPath: '/images/business_retail_dummy.svg',
    name: 'TRIAL.Korea Co.,Ltd.（関連会社）'
  }, {
    imgPath: '/images/business_retail_dummy.svg',
    name: 'F&G Retail Co.,Ltd.（関連会社）'
  }]
}, {
  id: 'retail-ai',
  anchorImgPath: '/images/business-retail-ai-links.svg',
  title: 'リテールAI事業',
  engTitle: 'Retail AI',
  titleImgPath: '/images/business-retail-ai.svg',
  businessContent: /*#__PURE__*/(0,jsx_runtime.jsxs)("p", {
    children: ["\u300C\u30C6\u30AF\u30CE\u30ED\u30B8\u30FC\u306B\u3088\u3063\u3066\u3001\u65B0\u6642\u4EE3\u306E\u304A\u8CB7\u3044\u7269\u4F53\u9A13\u3092\u751F\u307F\u51FA\u3057\u3001\u6D41\u901A\u306E\u4ED5\u7D44\u307F\u3092\u9769\u65B0\u3059\u308B\u300D\u3092\u30D3\u30B8\u30E7\u30F3\u3068\u3057\u3066\u3001IoT\u30C7\u30D0\u30A4\u30B9\u3092\u6D3B\u7528\u3057\u305F\u5404\u7A2E\u30BD\u30EA\u30E5\u30FC\u30B7\u30E7\u30F3\u3084\u30BD\u30D5\u30C8\u30A6\u30A7\u30A2\u30B5\u30FC\u30D3\u30B9\u3092\u63D0\u4F9B\u3057\u3066\u304A\u308A\u307E\u3059\u3002", /*#__PURE__*/(0,jsx_runtime.jsx)("br", {}), "Skip Cart\u7B49\u306E\u958B\u767A\u3092\u901A\u3058\u3066\u3001\u304A\u5BA2\u69D8\u306B\u65B0\u3057\u3044\u8CB7\u3044\u7269\u4F53\u9A13\u3092\u63D0\u4F9B\u3059\u308B\u3068\u3068\u3082\u306B\u3001CPG\uFF08\u6D88\u8CBB\u8CA1\uFF09\u30E1\u30FC\u30AB\u30FC\u3068\u306E\u5354\u50CD\u3084\u30C7\u30FC\u30BF\u306E\u6D3B\u7528\u306B\u3088\u3063\u3066\u6D41\u901A\u696D\u754C\u306B\u591A\u304F\u5B58\u5728\u3057\u3066\u3044\u308B\u300C\u30E0\u30C0\u30FB\u30E0\u30E9\u30FB\u30E0\u30EA\u300D\u306E\u524A\u6E1B\u3092\u76EE\u6307\u3057\u3066\u3044\u307E\u3059\u3002"]
  }),
  companies: [{
    path: 'http://www.trechina.com/',
    imgPath: '/images/business_TRIAL_Technology.png',
    name: '株式会社トライアルテクノロジー',
    isExternalLink: isExternalLink
  }, {
    link: 'https://www.retail-ai.jp/',
    imgPath: '/images/cardlink-logo-retail-ai.svg',
    name: '株式会社Retail AI',
    isExternalLink: isExternalLink
  }, {
    path: 'http://www.trechina.com/',
    imgPath: '/images/business_retail_ai_dummy.svg',
    name: '拓锐安（上海）科技有限公司',
    isExternalLink: isExternalLink
  }, {
    path: 'http://www.trechina.com/',
    imgPath: '/images/business_tre_china.png',
    name: '烟台创迹软件有限公司',
    isExternalLink: isExternalLink
  }, {
    path: 'http://www.trechina.com/',
    imgPath: '/images/business_retail_ai_dummy.svg',
    name: '上海翔迹企业管理有限公司',
    isExternalLink: isExternalLink
  }, {
    path: 'http://www.trechina.com/',
    imgPath: '/images/business_TRYU.png',
    name: '株式会社TRYU',
    isExternalLink: isExternalLink
  }, {
    link: 'https://salesplus.co.jp/',
    imgPath: '/images/sales-plus-logo.webp',
    name: '株式会社SalesPlus（関連会社）',
    isExternalLink: isExternalLink
  }, {
    link: 'https://www.retail-cix.jp/',
    imgPath: '/images/Logo_Retail-CIX.png',
    name: '株式会社RetailｰCIX（関連会社）',
    isExternalLink: isExternalLink
  }, {
    imgPath: '/images/business_retail_dummy.svg',
    name: 'GALILEI Media株式会社（関連会社）'
  }]
}, {
  id: 'others',
  anchorImgPath: '/images/business-other-links.svg',
  title: 'その他',
  engTitle: 'Other Business',
  titleImgPath: '/images/business-other.svg',
  businessContent: /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
    children: "\u4E0D\u52D5\u7523\u306E\u6240\u6709\u30FB\u6D3B\u7528\u53CA\u3073\u65C5\u9928\u696D\u3084\u3001\u3053\u3060\u308F\u308A\u306E\u6599\u7406\u3092\u63D0\u4F9B\u3059\u308B\u6599\u4EAD\u306A\u3069\u306E\u98F2\u98DF\u696D\u3001\u30B4\u30EB\u30D5\u5834\u904B\u55B6\u306A\u3069\u306E\u30EA\u30BE\u30FC\u30C8\u95A2\u9023\u4E8B\u696D\u3092\u884C\u3063\u3066\u304A\u308A\u307E\u3059\u3002"
  }),
  companies: [{
    link: 'https://trial-realestate.co.jp/',
    imgPath: '/images/business_TRIAL_Real_Estate.png',
    name: '株式会社トライアルリアルエステート',
    isExternalLink: isExternalLink
  }, {
    link: 'https://ted-trial-net.co.jp/',
    imgPath: '/images/business_TRIAL_Estate_Development.png',
    name: '株式会社トライアル開発',
    isExternalLink: isExternalLink
  }, {
    link: 'https://www.kawamurasatodesign.com/',
    imgPath: '/images/business-kawamura.webp',
    name: '株式会社河村佐藤デザイン',
    isExternalLink: isExternalLink
  }, {
    link: 'https://trial-golf-resort-wakamiya-course.com/',
    imgPath: '/images/business_TRIAL_Golf_Resort.png',
    name: '株式会社トライアルゴルフ&リゾート',
    isExternalLink: isExternalLink
  }, {
    link: 'https://trial-golf-resort-aso-course.com/',
    imgPath: '/images/business_TGR_Aso.png',
    name: '株式会社ティージーアール阿蘇',
    isExternalLink: isExternalLink
  }, {
    link: 'https://trial-golf-resort-oita-course.com/',
    imgPath: '/images/business_TGR_Oita.png',
    name: '株式会社ティージーアール大分',
    isExternalLink: isExternalLink
  }, {
    imgPath: '/images/business_trial_tours_dummy.svg',
    name: '株式会社トライアルツアーズ'
  }, {
    imgPath: '/images/business_others_dummy.svg',
    name: '株式会社トライアルヒューマンベース'
  }, {
    imgPath: '/images/business_others_dummy.svg',
    name: '株式会社トライアルベネフィット'
  }, {
    imgPath: '/images/business_others_dummy.svg',
    name: '株式会社トライアルチャレンジド'
  }, {
    imgPath: '/images/business_others_dummy.svg',
    name: '株式会社Fieldman'
  }]
}];
// EXTERNAL MODULE: ./src/components/elements/LinkCard/index.tsx + 1 modules
var LinkCard = __webpack_require__(53300);
// EXTERNAL MODULE: ./src/components/elements/SectionTitle/index.tsx
var SectionTitle = __webpack_require__(70770);
// EXTERNAL MODULE: ./src/components/elements/SectionTitleBackground/index.tsx
var SectionTitleBackground = __webpack_require__(75795);
// EXTERNAL MODULE: ./src/components/layout.tsx + 7 modules
var layout = __webpack_require__(55548);
// EXTERNAL MODULE: ./src/components/layouts/Head/index.tsx
var Head = __webpack_require__(22978);
;// CONCATENATED MODULE: ./src/components/pages/Business/index.tsx


var _excluded = ["name"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }











var BusinessPage = function BusinessPage() {
  var anchorLinks = businessLinks.map(function (v) {
    return {
      title: v.title,
      link: v.id,
      imgPath: v.anchorImgPath
    };
  });
  return /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Head/* Head */.F, {
      title: "\u4E8B\u696D\u5185\u5BB9",
      description: "\u30C8\u30E9\u30A4\u30A2\u30EB\u30DB\u30FC\u30EB\u30C7\u30A3\u30F3\u30B0\u30B9\u306E\u30B0\u30EB\u30FC\u30D7\u4F01\u696D\u306E\u4E00\u89A7\u3001\u53D6\u308A\u7D44\u3080\u4E8B\u696D\u5185\u5BB9\u3092\u63B2\u8F09\u3057\u3066\u3044\u307E\u3059\u3002",
      ogp: {
        url: 'business/'
      }
    }), /*#__PURE__*/(0,jsx_runtime.jsxs)(BusinessMain, {
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)(LinkWrapper, {
        children: /*#__PURE__*/(0,jsx_runtime.jsx)("ul", {
          children: anchorLinks.map(function (_ref) {
            var title = _ref.title,
                link = _ref.link,
                imgPath = _ref.imgPath;
            return /*#__PURE__*/(0,jsx_runtime.jsx)("li", {
              children: /*#__PURE__*/(0,jsx_runtime.jsx)(LinkCard/* LinkCard */.k, {
                title: title,
                link: link,
                imgPath: imgPath,
                isScroll: true
              })
            }, title);
          })
        })
      }), businessLinks.map(function (_ref2) {
        var id = _ref2.id,
            title = _ref2.title,
            engTitle = _ref2.engTitle,
            titleImgPath = _ref2.titleImgPath,
            businessContent = _ref2.businessContent,
            companies = _ref2.companies;
        return /*#__PURE__*/(0,jsx_runtime.jsxs)(BusinessItem, {
          id: id,
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)(SectionTitleBackground/* SectionTitleBackground */.T, {
            bgColor: "thin-blue",
            outerBgColor: "white",
            padding: {
              pc: '20px 200px 193px',
              sp: '0 0 68px'
            },
            children: /*#__PURE__*/(0,jsx_runtime.jsxs)(BusinessTitleWrapper, {
              children: [/*#__PURE__*/(0,jsx_runtime.jsx)(LogoWrapper, {
                children: /*#__PURE__*/(0,jsx_runtime.jsx)("img", {
                  src: titleImgPath,
                  width: 320,
                  height: 184,
                  alt: "\u30C8\u30E9\u30A4\u30A2\u30EB\u30DB\u30FC\u30EB\u30C7\u30A3\u30F3\u30B0\u30B9".concat(title)
                })
              }), /*#__PURE__*/(0,jsx_runtime.jsx)(SectionTitle/* SectionTitle */.N, {
                titleText: engTitle,
                subTitleText: title,
                color: "normal",
                as: "h2"
              }), /*#__PURE__*/(0,jsx_runtime.jsx)(Detail, {
                children: businessContent
              })]
            })
          }), /*#__PURE__*/(0,jsx_runtime.jsx)(BusinessLinks, {
            children: companies.map(function (_ref3) {
              var name = _ref3.name,
                  rest = (0,objectWithoutProperties/* default */.Z)(_ref3, _excluded);

              return /*#__PURE__*/(0,jsx_runtime.jsx)(LinkCard/* LinkCard */.k, _objectSpread({
                detail: name
              }, rest), name);
            })
          })]
        }, id);
      })]
    })]
  });
};

BusinessPage.getLayout = function (page) {
  var breadCrumbs = [{
    name: 'ホーム',
    path: '/'
  }, {
    name: '事業内容',
    path: ''
  }];
  return /*#__PURE__*/(0,jsx_runtime.jsx)(layout/* ImageTitleLayout */.Cr, {
    title: "Our Business",
    subTitle: "\u4E8B\u696D\u5185\u5BB9",
    imgUrl: "/images/top-business.webp",
    breadCrumbs: breadCrumbs,
    children: page
  });
};

var BusinessMain = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "Business__BusinessMain",
  componentId: "sc-1b27rfe-0"
})(["overflow:hidden;margin:98px auto 0;padding-bottom:130px;@media screen and (max-width:1047px){margin:40px auto 0;padding-bottom:70px;}"]);
var LinkWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "Business__LinkWrapper",
  componentId: "sc-1b27rfe-1"
})(["width:1040px;margin:0 auto;ul{display:flex;column-gap:46px;}@media screen and (max-width:1047px){width:100%;padding:0 20px;ul{flex-direction:column;align-items:center;row-gap:37px;}}"]);
var BusinessItem = styled_components_browser_esm/* default.section.withConfig */.ZP.section.withConfig({
  displayName: "Business__BusinessItem",
  componentId: "sc-1b27rfe-2"
})(["padding-top:105px;margin-top:5px;@media screen and (max-width:1047px){padding-top:73px;margin-top:7px;}"]);
var BusinessTitleWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "Business__BusinessTitleWrapper",
  componentId: "sc-1b27rfe-3"
})(["display:flex;flex-direction:column;justify-content:center;align-items:center;@media screen and (max-width:1047px){padding:92px 40px 0;}"]);
var LogoWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "Business__LogoWrapper",
  componentId: "sc-1b27rfe-4"
})(["margin-bottom:40px;z-index:8;@media screen and (max-width:1047px){position:absolute;top:-20px;img{width:160px;height:92px;}}"]);
var Detail = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "Business__Detail",
  componentId: "sc-1b27rfe-5"
})(["margin-top:48px;font-size:16px;line-height:30px;width:1040px;@media screen and (max-width:1047px){margin-top:30px;font-size:15px;line-height:25px;width:100%;}"]);
var BusinessLinks = styled_components_browser_esm/* default.ul.withConfig */.ZP.ul.withConfig({
  displayName: "Business__BusinessLinks",
  componentId: "sc-1b27rfe-6"
})(["display:flex;margin:70px auto 0;flex-wrap:wrap;gap:45px;width:1040px;@media screen and (max-width:1047px){width:100%;gap:38px;padding:0 20px;justify-content:center;}"]);
;// CONCATENATED MODULE: ./src/pages/business/index.tsx


/***/ }),

/***/ 18227:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/business",
      function () {
        return __webpack_require__(16415);
      }
    ]);
    if(false) {}
  

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [1228,3874,2768,8517,5548,9774,2888,179], function() { return __webpack_exec__(18227); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);